















import Vue from 'vue'
import TrackingTable from '@/UI/Tracking/TrackingTable.vue'
import ProcedureDetailForm from '@/UI/Procedures/ProcedureDetailForm.vue'
import { ProcedureDto } from '@/Application/Procedures'
import { FetchTrackingCommandHandlerProvider } from '@/Infrastructure/Tracking/Provider/FetchTrackingCommandHandlerProvider'
import { FetchTrackingCommand } from '@/Application/Tracking/FetchTrackingCommand'
import { TrackingDTO } from '@/Application/Tracking/TrackingDTO'

interface TrackingInt {
  datosT: TrackingDTO[];
  timer: NodeJS.Timer | null;
  loading: boolean;
}

export default Vue.extend({
  name: 'TrackingLayout',
  components: { TrackingTable, ProcedureDetailForm },
  data (): TrackingInt {
    return {
      datosT: [],
      timer: null,
      loading: false
    }
  },
  props: {
    procedure: {
      type: Object as () => ProcedureDto,
      required: true
    }
  },
  created () {
    this.loadData()
    this.timer = setInterval(this.loadData, 30000)
  },
  methods: {
    loadData (): Promise<void> {
      this.loading = true
      return this.loadBatches()
        .then((response: TrackingDTO[]) => {
          let orderedBatches = response
          if (response[0] && response[0].orde) {
            orderedBatches = this.sortBatchesByOrder(orderedBatches)
          }
          this.datosT = orderedBatches
        })
        .finally(() => {
          this.loading = false
        })
    },
    loadBatches (): Promise<TrackingDTO[]> {
      const provider = new FetchTrackingCommandHandlerProvider()
      const command = new FetchTrackingCommand(this.procedure.procedureId)
      const handler = provider.provide()
      return handler.handle(command)
    },
    cancelAutoUpdate () {
      if (this.timer !== null) {
        clearInterval(this.timer)
      }
    },
    sortBatchesByOrder (batches: TrackingDTO[]) {
      return batches.sort((a: TrackingDTO, b: TrackingDTO): number => {
        return parseInt(a.orde, 10) - parseInt(b.orde, 10)
      })
    }
  },
  beforeDestroy () {
    if (this.timer !== null) {
      clearInterval(this.timer)
    }
  }
})
